enum UiLanguage {
	en = "en",
	ru = "ru",
}

export const defaultLanguage = UiLanguage.en;

export const browserLanguage = (): UiLanguage | undefined => {
	if (typeof navigator === "undefined") return undefined;
	return UiLanguage[navigator.language?.split("-")[0] as keyof typeof UiLanguage];
};

export default UiLanguage;
